import PropTypes from "prop-types";

const TabSection = ({
  title,
  description,
  children,
  padding = "py-8",
  showBorder = true,
  badge,
}) => {
  return (
    <div
      className={`grid grid-cols-1 gap-x-8 gap-y-8 ${padding} px-4 sm:px-6 lg:px-8 md:grid-cols-3`}
    >
      <div className="px-0">
        <div className="flex items-center gap-2">
          <h2 className="text-base/7 font-semibold text-ink-900">{title}</h2>
          {badge && (
            <span className="inline-flex items-center px-1.5 py-0.5 rounded text-xs font-medium bg-accent-100 text-accent-600">
              {badge}
            </span>
          )}
        </div>
        <p className="mt-1 text-sm/6 text-ink-600">{description}</p>
      </div>

      <div
        className={`bg-white shadow-hairline ring-1 ring-ink-100 sm:rounded-card md:col-span-2 ${
          showBorder ? "" : "border-0"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

TabSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  padding: PropTypes.string,
  showBorder: PropTypes.bool,
  badge: PropTypes.string,
};

export default TabSection;
